export const stepcountsConstants = {
    CLEAR_PAGE_STATE: 'CLEAR_STEP_COUNT_STATE',
    OPEN_ADD_NEW_STEP_COUNTS: 'OPEN_ADD_NEW_STEP_COUNTS',
    OPEN_EDIT_STEP_COUNTS: 'OPEN_EDIT_STEP_COUNTS',
    CLOSE_FORM_STEP_COUNTS: 'CLOSE_FORM_STEP_COUNTS',
    ADD_STEP_COUNTS_SUCCESS: 'ADD_STEP_COUNTS_SUCCESS',
    EDIT_STEP_COUNTS_SUCCESS: 'EDIT_STEP_COUNTS_SUCCESS',
    TABLE_RELOAD_SUCCESS: 'TABLE_RELOAD_SUCCESS',

    GET_STEP_COUNTS_DATA_SUCCESS: 'GET_STEP_COUNTS_DATA_SUCCESS',
    STEPCOUNTS_FORM_PRODUCT_LIST_LOADER: 'STEPCOUNTS_FORM_PRODUCT_LIST_LOADER',
    GET_PRODUCT_LIST_SUCCESS: 'GET_PRODUCT_LIST_SUCCESS',
    STEP_COUNT_TYPECODE_SELECTED_PRODUCT_ITEM: 'STEP_COUNT_TYPECODE_SELECTED_PRODUCT_ITEM',
    STEP_COUNT_TYPECODE_SELECTED_MANY_PRODUCT_ITEM: 'STEP_COUNT_TYPECODE_SELECTED_MANY_PRODUCT_ITEM',
    STEP_COUNT_TYPECODE_DESELECTED_PRODUCT_ITEM: 'STEP_COUNT_TYPECODE_DESELECTED_PRODUCT_ITEM',
    ON_STEPCOUNT_TYPE_CHANGE_TO_CODE: 'ON_STEPCOUNT_TYPE_CHANGE_TO_CODE',
    ON_STEPCOUNT_TYPE_CHANGE_TO_PRODUCT: 'ON_STEPCOUNT_TYPE_CHANGE_TO_PRODUCT',

    DELETE_STEP_COUNTS_SUCCESS: 'DELETE_STEP_COUNTS_SUCCESS',

    SHOW_TABLE_LOADER: 'SHOW_STEPCOUNT_TABLE_LOADER',
    HIDE_TABLE_LOADER: 'HIDE_STEPCOUNT_TABLE_LOADER',

    GET_MEMBER_LEVEL_LIST_SUCCESS: 'GET_MEMBER_LEVEL_LIST_SUCCESS',

    STEP_COUNT_ADD_JOINED_PRODUCT: 'STEP_COUNT_ADD_JOINED_PRODUCT',
    STEP_COUNT_ADD_JOINED_PRODUCT_ROW: 'STEP_COUNT_ADD_JOINED_PRODUCT_ROW',
    STEP_COUNT_DELETE_JOINED_PRODUCT: 'STEP_COUNT_DELETE_JOINED_PRODUCT',
    STEP_COUNT_ADD_SINGLE_PRODUCT: 'STEP_COUNT_ADD_SINGLE_PRODUCT',

    STEP_COUNT_GET_REGION_LIST:"STEP_COUNT_GET_REGION_LIST",
    STEP_COUNT_GET_SHOP_LIST:"STEP_COUNT_GET_SHOP_LIST",
    STEP_COUNT_SELECT_SHOP:"STEP_COUNT_SELECT_SHOP",
    STEP_COUNT_UNSELECT_SHOP:"STEP_COUNT_UNSELECT_SHOP",
    STEP_COUNT_FILTER_SELECTED_SHOP_BY_REGION:"STEP_COUNT_FILTER_SELECTED_SHOP_BY_REGION",
    STEP_COUNT_SELECTED_REGION:"STEP_COUNT_SELECTED_REGION",
    STEP_COUNT_SELECT_ALL_SHOP_LIST:"STEP_COUNT_SELECT_ALL_SHOP_LIST",
    STEP_COUNT_UNSELECT_ALL_SHOP_LIST:"STEP_COUNT_UNSELECT_ALL_SHOP_LIST",
    STEP_COUNT_SEARCH_SHOP_LIST:"STEP_COUNT_SEARCH_SHOP_LIST",
    STEP_COUNT_SEARCH_SHOP_SELECTED:"STEP_COUNT_SEARCH_SHOP_SELECTED",
    STEP_COUNT_CLEAR_SHOP_LIST:"STEP_COUNT_CLEAR_SHOP_LIST",
    GET_LUCKY_DRAW_REWARD_SET_SUCCESS:"GET_LUCKY_DRAW_REWARD_SET_SUCCESS",

    OPEN_STEP_COUNT_FORM_IMPORT: 'OPEN_STEP_COUNT_FORM_IMPORT',
    CLOSE_STEP_COUNT_FORM_IMPORT: 'CLOSE_STEP_COUNT_FORM_IMPORT',
    SHOW_STEP_COUNT_IMPORT_PRODUCT_RESULT: 'SHOW_STEP_COUNT_IMPORT_PRODUCT_RESULT',
    HIDE_STEP_COUNT_IMPORT_PRODUCT_RESULT: 'HIDE_STEP_COUNT_IMPORT_PRODUCT_RESULT',

    SET_FORM_PREVIEW_IMAGE_REWARD: 'SET_FORM_PREVIEW_IMAGE_REWARD',
}